const NavigationSelectedItemState = {
  Measurementpoints: 'Measurementpoints',
  AnalysisSamples: 'AnalysisSamples',
  WaterSamples: 'WaterSamples',
  AirSamples: 'AirSamples'
}

export default NavigationSelectedItemState
